
/* injects from baggage-loader */

import React, { Component } from "react";
import { UIMixin } from "../../../mixins/uiMixin";
import { connect } from "react-redux";
import PropTypes from "prop-types";
import CountDownComponent from "../countDownClock";

class UserActionOK extends Component {
    render () {
        return <div className="ticket-results-view-p">
            <CountDownComponent second={15}/>
            <h3>{this.props.data}</h3>
            <div className="buttons-view-w-t">
                <ul>
                    <li>
                        <div className="separator-box-buttons-m">
                            <button className="button-view-normal-m"
                                    onClick={this.props.closePopup()}>
                                OK
                            </button>
                        </div>
                    </li>
                </ul>
            </div>
        </div>;
    }
}

UserActionOK.propTypes = {
    closePopup: PropTypes.func,
    data: PropTypes.string,
    popupType: PropTypes.string
};

export default connect()(UIMixin({Component: UserActionOK}));